import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { GoogleBigQueryObjectDataset } from 'app/model/dataset/google-bigquery.dataset';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';
import { merge } from 'lodash';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(GoogleBigQueryObjectDataset),
    asynchronous: true,
    disabled: __IS_FABRIC_DPE__,
    adapts: merge({
        properties: {
            typeProperties: {
                dataset: '*'
            }
        }
    }, tabularTypeDatasetAdapts)
})
export class GoogleBigQueryObjectDatasetAdapter extends TabularTypeDatasetAdapter<GoogleBigQueryObjectDataset, Model.DatasetResource> {
    protected async _toResource(dataset: GoogleBigQueryObjectDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(GoogleBigQueryObjectDataset).name, undefined, 'dataset');
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: GoogleBigQueryObjectDataset): Promise<GoogleBigQueryObjectDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, GoogleBigQueryObjectDataset.MODEL, undefined, 'dataset');
    }
}
